// Total verbs the Verb Conjugation page lists: the entries with a verbType
// across public/vocab-data/n1-n5.json (the pool ConjugationPage.tsx filters
// from) minus the ones on the exclusion list in verbExceptions.ts (2,733 tagged
// entries, 1 excluded). Kept as a constant so the homepage progress bar doesn't
// have to download every level's word list just to count them -
// verbTotal.test.ts fails if the data files or the exclusion list drift.
export const VERB_TOTAL = 2732;
